import type { FormSchema } from '@cli-types/core-engine/schema.js'
import type { WebhookEventsResult } from '@cli-types/next-adapter/generators.js'
import { createGeneratedFile } from '@cli-utils/files.js'
import { toKebabCase } from '@cli-utils/text.js'
import { renderExtract } from './render-extract.js'

export function updateFormWebhookEvents(
  schema: FormSchema,
  webhookEventsDir: string
): WebhookEventsResult {
  const kebabName = toKebabCase(schema.name)

  return {
    files: [
      createGeneratedFile(
        `${webhookEventsDir}/${schema.name}.ts`,
        renderExtract(schema.name, 'form', schema.label, [`form.${kebabName}.submitted`], kebabName)
      )
    ]
  }
}
